import { Component } from '@angular/core';
import { NavController, ViewController, NavParams } from 'ionic-angular';

import { CustomSplashHandlerProvider } from '../../providers/custom-splash-handler';

@Component({
  selector: 'page-custom-splash',
  templateUrl: 'custom-splash.html',
})
export class CustomSplashPage {
	msg: any = "Starting up";

	constructor(
		public customSplashHandlerProvider: CustomSplashHandlerProvider, 
		public viewCtrl: ViewController,
		public navCtrl: NavController, 
		public navParams: NavParams) {
		customSplashHandlerProvider.subscription.subscribe(params => {
			this.msg = params.msg;			

			if(params.finished){
				setTimeout(()=>{
					this.viewCtrl.dismiss();
				}, 600)				
			}
		});
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad CustomSplashPage');
	}

}



// WEBPACK FOOTER //
// ./src/pages/custom-splash/custom-splash.ts